const MS_PER_DAY = 86_400_000;

export function ticketAgeDays(
  ticket: { opened_at?: string | null; closed_at?: string | null },
  now = Date.now(),
): number {
  if (!ticket.opened_at) return 0;
  const start = Date.parse(ticket.opened_at);
  const end = ticket.closed_at ? Date.parse(ticket.closed_at) : now;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return 0;
  return Math.floor((end - start) / MS_PER_DAY);
}

export function formatTicketAge(days: number): string {
  return days === 1 ? "1 day" : `${days} days`;
}

export function ticketContactName(ticket: {
  contact_first_name?: string | null;
  contact_last_name?: string | null;
}): string {
  return `${ticket.contact_first_name ?? ""} ${ticket.contact_last_name ?? ""}`.trim();
}

export function ticketNumberLabel(ticket: {
  ticket_number?: string | null;
  title?: string | null;
}): string {
  const number = ticket.ticket_number?.trim();
  if (number) return number;
  return ticket.title?.trim() || "Ticket";
}
